import { Component, OnInit } from '@angular/core';
import { User } from '../_models/index';
import { UserService } from '../_services/index';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
    moduleId: module.id.toString(),
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css']
})

export class HomeComponent implements OnInit {
    currentUser: User;
    users: User[] = [];
    is_country_fp = false;

    constructor(private userService: UserService, private router: Router) {
    }

    ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        var currentUserId = JSON.parse(localStorage.getItem('currentUserId'));
        if(currentUserId)
        this.is_country_fp = currentUserId.country_focal_point;
        this.loadAllUsers();
    }

    deleteUser(id: number) {
        this.userService.delete(id).subscribe(() => { this.loadAllUsers() });
    }

    private loadAllUsers() {
        this.userService.getAll().subscribe(users => { this.users = users; });
    }

    introBtnClick(){
        this.router.navigateByUrl('/introduction/intro-home')
    }
    compBtnClick(){
        this.router.navigateByUrl('/sdg/sdg-home')
        $(".header_active").removeClass("header_active")
        $(".home-click").addClass("header_active")
    }
    viewSummaryBtnClick(){
        this.router.navigateByUrl('/view-summary')
    }

    onlineCourseBtnClick(){
      this.router.navigateByUrl('/online-course')
    }
    logoutClick(){
        localStorage.setItem('editmode', '0');
        this.router.navigateByUrl('/login')
    }
    adminClick(){
        this.router.navigateByUrl('/admin')
    }
    register1Click(){
        this.router.navigateByUrl('/register')
    }
    loginClickHome(){
        this.router.navigateByUrl('/login')
    }
    profileClick(){
        this.router.navigateByUrl('/profile')
    }
    manageTeamClick(){
        this.router.navigateByUrl('/manage-team')
    }
    feedbackClick(){
        this.router.navigateByUrl('/feedback')
    }
    profileIconClick(){
      $('.dropdown-content').slideToggle(400, 'swing');
    }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts